import React from "react";
import { EmptyStateContainer } from "./styles";
import { ParagraphM } from "../../atoms/Typography";
import { Theme } from "../../atoms/theme";

interface EmptyStateProps {
  content?: React.ReactElement;
  columnCount: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  content,
  columnCount,
}) => {
  if (content) {
    return (
      <EmptyStateContainer>
        <td colSpan={columnCount}>{content}</td>
      </EmptyStateContainer>
    );
  }

  return (
    <EmptyStateContainer>
      <td colSpan={columnCount}>
        <div className="flex flex-col items-center justify-center">
          <ParagraphM
            style={{ marginBottom: ".5rem" }}
            color={Theme.colors.neutrals_100}
          >
            No records yet
          </ParagraphM>
          <ParagraphM color={Theme.colors.neutrals_200}>
            There are no records to display at the moment
          </ParagraphM>
        </div>
      </td>
    </EmptyStateContainer>
  );
};
